export class ListUtil {
  public static union<T>(list1: T[], list2: T[]): T[] {
    const result = list1.slice();
    result.push(...list2);
    return ListUtil.distinct(result);
  }

  public static distinct<T>(list: T[]): T[] {
    return Array.from(new Set(list));
  }
}
